declare var wp: any;

namespace TotalPoll {
    import Component = TotalCore.Common.Component;

    @Component('components.totalpoll', {
        templateUrl: 'introduction-component-template',
        bindings: {}
    })
    class IntroductionComponent {

        public constructor(private $scope) {

        }
    }
}
